import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollManager() {
  const location = useLocation()

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (location.hash) document.getElementById(location.hash.slice(1))?.scrollIntoView()
      else window.scrollTo({ top: 0 })
    }, 0)
    return () => window.clearTimeout(timer)
  }, [location.pathname, location.hash])

  return null
}
